// schedule-insert.ts — the single source of truth for "append a timed event
// stamp to the current line", shared by the /schedule slash command
// (autocomplete.ts) and the mobile keyboard bar's event button
// (mobile-keyboard-accessory.ts).
//
// A schedule line is `<description> > YYMMDD HHMM HHMM`, so the stamp is
// appended at the END of the line (the description precedes the `>`) and the
// caret lands right before the ` > …` tail — ready to type / extend the
// description. This kills the old /schedule behaviour of caret-at-START, which
// left a stray leading space when the user typed nothing.
//
// Pure leaf: imports ONLY the date helpers (no note-editor / autocomplete /
// mobile import → no cycle), mirroring the ghost-suggestion.cm.ts leaf pattern.

import { nowTimeRange, toYYMMDD } from '../utils/dates.js';

/**
 * Append ` > YYMMDD HHMM HHMM` (now → +1h) to the end of the line containing
 * `from`, removing any `[from, to)` range first (so the caller can pass the
 * `/schedule` token span for it to be wiped; pass `from === to` to insert with
 * nothing removed). The caret lands immediately before the appended tail.
 */
export function insertEvent(view: any, from: number, to: number): void {
  const line = view.state.doc.lineAt(from);
  const tail = ` > ${toYYMMDD(new Date())} ${nowTimeRange()}`;
  const removed = Math.max(0, to - from);
  // Caret sits right before the leading space of the appended tail. line.to is
  // the pre-change line end; subtracting `removed` accounts for the token we
  // wipe (which lies within this line, before line.to).
  const caret = line.to - removed;
  view.dispatch({
    changes: removed
      ? [
          { from, to, insert: '' },
          { from: line.to, insert: tail },
        ]
      : { from: line.to, insert: tail },
    selection: { anchor: caret },
  });
}
